/* @jsxImportSource react */

import type { ReactNode } from 'react';

export type MinimalHeaderLayoutProps = {
  children?: ReactNode;
};

export const MinimalHeaderLayout = ({ children }: MinimalHeaderLayoutProps) => (
  <>
    {/* Outer <header> stays full-bleed (no width cap of its own) so a background/shadow spans
        the full viewport; shop-content caps and centers the actual content — same split as
        ResponsiveHeaderLayout. */}
    <header className="w-full max-lg:shadow-sm">
      <div className="page-header shop-content grid">{children}</div>
    </header>

    <div className="border-color-grey border-b max-lg:hidden" />
  </>
);
